import { render, staticRenderFns } from "./oaplan.vue?vue&type=template&id=2acb05a8&scoped=true"
import script from "./oaplan.vue?vue&type=script&lang=js"
export * from "./oaplan.vue?vue&type=script&lang=js"
import style0 from "./oaplan.vue?vue&type=style&index=0&id=2acb05a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb05a8",
  null
  
)

export default component.exports